/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    SgSptRegionHelperModalEuropeHeader: {
        id: 'qnb.spt.SgSptRegionHelperModal.EuropeHeader',
        defaultMessage: 'Europe'
    },
    SgSptRegionHelperModalEuropeParagraph: {
        id: 'qnb.spt.SgSptRegionHelperModal.EuropeParagraph',
        defaultMessage: 'The region Europe includes all the destinations in the following list.'
    },
    SgSptRegionHelperModalWorldwideHeader: {
        id: 'qnb.spt.SgSptRegionHelperModal.WorldwideHeader',
        defaultMessage: 'Worldwide options'
    },
    SgSptRegionHelperModalWorldwideFirstParagraph: {
        id: 'qnb.spt.SgSptRegionHelperModal.WorldwideFirstParagraph',
        defaultMessage: 'If you need cover for any of the destinations listed below then choose the region \'Worldwide including USA, Canada, Mexico and all Caribbean islands\'.'
    },
    SgSptRegionHelperModalWorldwideSecondParagraph: {
        id: 'qnb.spt.SgSptRegionHelperModal.WorldwideSecondParagraph',
        defaultMessage: 'The region \'Worldwide excluding USA, Canada, Mexico and all Caribbean islands\' covers all destinations except those listed here.'
    },
    SgSptRegionHelperModalHeaderUSA: {
        id: 'qnb.spt.SgSptRegionHelperModal.ModalHeaderUSA',
        defaultMessage: 'List of destinations in USA, Canada, Mexico & Caribbean islands'
    },
    SgSptRegionHelperModalAlternativeHeader: {
        id: 'qnb.spt.SgSptRegionHelperModal.ModalAlternativeHeader',
        defaultMessage: 'There are three regions available under our annual travel insurance'
    },
    SgSptRegionHelperModalAlternativeWorldwideFirstParagraph: {
        id: 'qnb.spt.SgSptRegionHelperModal.AlternativeWorldwideFirstParagraph',
        defaultMessage: 'The region ‘Worldwide including USA, Canada, Mexico and all Caribbean islands’ includes all the destinations in the following list.'
    },
    SgSptRegionHelperModalAlternativeWorldwideThirdParagraph: {
        id: 'qnb.spt.SgSptRegionHelperModal.AlternativeWorldwideThirdParagraph',
        defaultMessage: 'If you need to change the region on your policy, please contact us via '
    },
    SgSptRegionHelperModalAlternativeWorldwideThirdParagraphWebChat: {
        id: 'cep.components.SgEndorsementInfo.SgSptRegionHelperModalAlternativeWorldwideThirdParagraphWebChat',
        defaultMessage: 'web chat.'
    },
    SgSptRegionHelperModalAlternativeWorldwideThirdParagraphAlternatively: {
        id: 'cep.components.SgEndorsementInfo.SgSptRegionHelperModalAlternativeWorldwideThirdParagraphAlternatively',
        defaultMessage: ' Alternatively, you can call us on 0800 904 7764 and we will help you find the cover that is right for you.'
    },
    SgSptRegionHelperModalCloseButtonLabel: {
        id: 'qnb.spt.SgSptRegionHelperModal.CloseButtonLabel',
        defaultMessage: 'Close'
    },
    SgSptRegionHelperNotSureHeader: {
        id: 'qnb.spt.SgSptRegionHelperModal.SgSptRegionHelperNotSureHeader',
        defaultMessage: 'Not sure which region you need cover for?'
    },
    SgSptRegionHelperSearchPlaceholder: {
        id: 'qnb.spt.SgSptRegionHelperModal.SgSptRegionHelperSearchPlaceholder',
        defaultMessage: 'Start typing a destination...'
    },
    SgSptRegionHelperSearchNoMatch: {
        id: 'qnb.spt.SgSptRegionHelperModal.SgSptRegionHelperSearchNoMatch',
        defaultMessage: 'No results match {value}'
    },
    SgSptRegionResult: {
        id: 'qnb.spt.SgSptRegionHelperModal.SgSptRegionResult',
        defaultMessage: '{country} is included in the region {region}'
    },
    Region_europe: {
        id: 'qnb.spt.SgSptRegionHelperModal.Region_europe',
        defaultMessage: 'Europe'
    },
    Region_world_incl: {
        id: 'qnb.spt.SgSptRegionHelperModal.Region_wwi',
        defaultMessage: 'Worldwide including USA, Canada, Mexico and all Caribbean islands'
    },
    Region_world_excl: {
        id: 'qnb.spt.SgSptRegionHelperModal.Region_wwe',
        defaultMessage: 'Worldwide excluding USA, Canada, Mexico and all Caribbean islands'
    }
});
